import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
    { to: "/aanbod", label: "Aanbod" },
    { to: "/inruil#form", label: "Verkoop uw wagen" },
    { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200" data-testid="site-navbar">
            <div className="ucs-container flex items-center justify-between h-24">
                <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
                    <img src="/brand/logo.png" alt="Used Car Selection" className="h-16 w-auto" />
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace("/", "")}`}
                            className={({ isActive }) =>
                                `text-sm font-semibold tracking-wide transition-colors ${
                                    isActive ? "text-[#EC6A0A]" : "text-[#0E2C4D] hover:text-[#EC6A0A]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <Link to="/aanbod" className="ucs-btn-accent text-sm" data-testid="nav-cta-bekijk-aanbod">
                        Bekijk aanbod
                    </Link>
                </div>

                <button onClick={() => setOpen(!open)} className="md:hidden p-2" data-testid="navbar-mobile-toggle">
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-slate-200 bg-white" data-testid="navbar-mobile-menu">
                    <div className="ucs-container py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                                  className="text-base font-semibold text-[#0E2C4D]"
                                  data-testid={`mobile-nav-${l.to.replace("/", "")}`}>
                                {l.label}
                            </Link>
                        ))}
                        <Link to="/aanbod" onClick={() => setOpen(false)} className="ucs-btn-accent text-sm justify-center">
                            Bekijk aanbod
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};
